export default "https://assets.egbcdn.net/assets/packs/_/images/app/android/android-ru-3-b6550fe041ce7e9ece7345846f0358be.png";